<script>
    import ToolLink from "./ToolLink.svelte";

    export let subsection;
</script>


<div class="subsection">
    {#if subsection.title}
        <div class="title">
            {subsection.title}
        </div>
    {/if}
    <div class="subsection-content">
        {#each subsection.tools as tool}
            <ToolLink tool={tool}/>
        {/each}
    </div>
</div>

<style>
    .subsection {
        width: max-content;

    }

    .subsection > .title {
        font-size: 1.1em;
        text-transform: uppercase;
        margin-right: .5em;
        margin-bottom: .5em;
        padding-bottom: .3em;
        border-bottom: solid var(--theme-colors-text) 1px;
    }

    .subsection-content {
        display: flex;
        flex-wrap: wrap;
    }
</style>